module.exports = __webpack_public_path__ + "img/default.6f8064a3.svg";